import { IContextClient } from "@multiweb/clients/context/IContextClient";
import { CancellationToken } from "@multiweb/types/multiweb";
import { ASServices, getServiceURL } from "OW.Remoting/Basic/ServiceEndpoints";
import { BaseClient } from "../BaseClient";

/**
 * @internal
 */
export class ContextClient extends BaseClient implements IContextClient {
    public createContext(cancellationToken?: CancellationToken): Promise<string> {
        return this._communicationManager.callGETRequest("CreateContext", ASServices.context, undefined, undefined, { cancellationToken });
    }

    public async commitContext(contextId: string, cancellationToken?: CancellationToken): Promise<boolean> {
        await this._communicationManager.waitForContextRequests(contextId);

        return this._communicationManager.jsonRequest(
            "CommitContext",
            undefined,
            "GET",
            getServiceURL(ASServices.context),
            {
                ContextID: contextId,
            },
            { cancellationToken }) as Promise<boolean>;
    }

    public async rollbackContext(contextId: string, cancellationToken?: CancellationToken): Promise<boolean> {
        await this._communicationManager.waitForContextRequests(contextId);

        return this._communicationManager.jsonRequest(
            "RollbackContext",
            undefined,
            "GET",
            getServiceURL(ASServices.context),
            {
                ContextID: contextId,
            },
            { cancellationToken }) as Promise<boolean>;
    }
}
